export const contemporaryGroupRules =  {
  groupName: [
    v => !!v || 'Group name is required',
  ],
  birthYearRange: [
    v => !!v || 'Birth Year range is required',
  ],
  birthSex: [
    v => !!v || 'Birth sex is required',
  ],
  birthWeightRange: [
    v => !!v || 'Birth weight range is required',
  ],
  seasonOfBirth: [
    v => !!v || 'Season of birth range is required',
  ],
  primaryBreed: [
    v => !!v || 'Primary breed is required',
  ],
  secondaryBreed: [
    v => !!v || 'Secondary breed is required',
  ],
  composition: [
    v => !!v || 'Composition is required',
  ],
  conception: [
    v => !!v || 'Conception Method is required',
  ],
  weaningWeightRange: [
    v => !!v || 'Weaning weight range is required',
  ],
  dateWeightedRange: [
    v => !!v || 'Date Weight range is required',
  ],
  weaningSex: [
    v => !!v || 'Weaning sex is required',
  ],
  yearlingSex: [
    v => !!v || 'Yearling sex is required',
  ],
  yearlingWeightRange: [
    v => !!v || 'Yearling weight range is required',
  ],
  daysOnFeed: [
    v => !!v || 'Days on feed is required',
  ],
  carcassSex: [
    v => !!v || 'Carcass sex is required',
  ],
  carcassWeightRange: [
    v => !!v || 'Carcass weight range is required',
  ],
  breedOfDom: [
    v => !!v || 'Beer of dom is required',
  ],
  harvestDateRange: [
    v => !!v || 'Harvest date range is required',
  ],
  gradingDateRange: [
    v => !!v || 'Grading date range is required',
  ],
  dateOnFeedRange: [
    v => !!v || 'Date on feed range is required',
  ],
  fatThicknessRange: [
    v => !!v || 'Fat thickness range is required',
  ],
  ribEyeAreaRange: [
    v => !!v || 'Rib Eye Area range is required',
  ],
  kphRange: [
    v => !!v || 'KPH range is required',
  ],
  marblingRange: [
    v => !!v || 'Marbling range is required',
  ]
}